import { currentDept, switchDept } from '@/api/dept'
import { deptList } from '../../api/hospital'
class deptDTO {
    /**
     * 获取当前登录医馆
     */
    static getCurrentDept(params) {
        return new Promise((resolve, reject) => {
            currentDept(params).then(res => {
                resolve(res)
            })
        }).catch(() => {
            resolve({ code: 500 })
        })
    }

    /**
     * 切换医馆
     */
    static switchDept(params) {
        return new Promise((resolve, reject) => {
            switchDept(params).then(res => {
                resolve(res)
            })
        }).catch(() => {
            resolve({ code: 500 })
        })
    }

    /**
     * 切换并获取医馆
     */
    static switchAndGetDept(params) {
        return new Promise(async (resolve, reject) => {
            let { code, data } = await switchDept(params)
            if (code == 200) {
                currentDept(params).then(res => {
                    resolve(res)
                })
            }
        })
    }
    //获取所有医馆
    static getDeptList(params) {
      return new Promise(async (resolve, reject) => {
          let { code, rows } = await deptList(params)
          if (code == 200) {
              resolve(rows)
          }else{
            resolve([])
          }
      }).catch(() => {
          resolve([])
      })
  }
}
export { deptDTO }
